import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=252ba4e8&scoped=true"
import script from "./ChatRoom.vue?vue&type=script&lang=js"
export * from "./ChatRoom.vue?vue&type=script&lang=js"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=252ba4e8&prod&lang=css"
import style1 from "./ChatRoom.vue?vue&type=style&index=1&id=252ba4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ba4e8",
  null
  
)

export default component.exports